<template>
  <vxe-modal v-model="visible" :loading="loading" title="title.supplyQuantityMaintain" type="confirm" width="40%" @confirm="confirm">
    <vxe-form ref="form" :data="item" border span="24" title-align="center" title-background>
      <vxe-form-item :item-render="{name:'VxeInput',props:{editable:false}}" field="no" title="business.label.itemNo"/>
      <vxe-form-item :item-render="{name:'VxeInput',props:{editable:false}}" field="name" title="business.label.itemName"/>
      <vxe-form-item field="owners" title="business.label.owner">
        <template #default="{ row }">{{getStrings(row.owners, 'name')}}</template>
      </vxe-form-item>
      <vxe-form-item :item-render="{name:'VxeNumberInput',props:{min:0}}" field="numberOfSupply" title="business.label.supplyQuantity"/>
    </vxe-form>
  </vxe-modal>
</template>

<script>
import { findOne, save } from '@/api/Api'
import { Item } from '@/api/dto/common/Item'
import { getStrings } from '@/utils/util'

export default {
  data() {
    return {
      visible: false,
      loading: false,
      item: new Item()
    }
  },
  methods: {
    getStrings,
    open(itemId) {
      this.visible = true
      this.loading = true
      findOne('itemFactory', { id: itemId }).then(res => {
        if (res.success) {
          this.item = new Item(res.result)
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.loading = true
      const item = this.item.toJSONObject()
      save('itemPersister', item).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.saveSuccess'))
          this.visible = false
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>